import httprequest from "@/utils/request";

// 获取七牛token（针对gpt）
export function getQiniuGptTokenApi() {
  return httprequest({
    url: `/api/v2/upload/token`,
    method: "get",
  });
}

// 获取首页分类模板
export function HotClassifyList() {
  return httprequest({
    url: "/api/v2/chat-category",
    method: "get",
    showLoad: false,
    hideError: true,
  });
}
// 获取首页分类列表数据
export function classifyContent(id) {
  return httprequest({
    url: `/api/v2/chat-template?category_id=${id}`,
    method: "get",
    showLoad: false,
    isCDN: true,
  });
}

// 获取key
export function getChatKey() {
  return httprequest({
    url: "/api/v2/chat-key",
    method: "get",
    showLoad: false,
  });
}

// 获取机器人列表
export function getTemplatesy() {
  return httprequest({
    url: "/api/v2/chat-templates",
    method: "get",
    showLoad: false,
  });
}

// 换取key
export function getAgainKey(prm) {
  return httprequest({
    url: `/api/v2/chat-key?expire=1&${prm}`,
    method: "get",
    showLoad: false,
  });
}

//  获取使用次数
export function chatCount(method) {
  return httprequest({
    url: "/api/v2/chat-count",
    method: method,
    showLoad: false,
  });
}

//  获取应用列表数据
export function chatTemplate() {
  return httprequest({
    url: "/api/v2/app-template",
    method: "get",
    showLoad: false,
    isCDN: true,
    dataStatus: 1,
  });
}
//  获取应用列表（类型）数据
export function chatTemplateCategory(category_id) {
  return httprequest({
    url: `/api/v2/app-template/category?category_id=${category_id}`,
    method: "get",
    showLoad: false,
    dataStatus: 1,
  });
}
// 获取自定义应用列表数据
export function getCustomApplyList() {
  return httprequest({
    url: "/api/v2/custom-app",
    method: "get",
    showLoad: false,

    dataStatus: 1,
  });
}
// 创建自定义应用
export function createCustomApplyApi(data) {
  return httprequest({
    url: "/api/v2/custom-app",
    method: "post",
    showLoad: false,
    data,

    dataStatus: 1,
  });
}
// 编辑自定义应用
export function editCustomApplyApi(data) {
  return httprequest({
    url: "/api/v2/custom-app",
    method: "put",
    showLoad: false,
    data,
    dataStatus: 1,
  });
}

// 克隆默认应用
export function cloneDefaultApplyApi(type) {
  return httprequest({
    url: `/api/v2/custom-app/copy?key=${type}`,
    method: "post",
    showLoad: false,

    dataStatus: 1,
  });
}
// 删除自定义应用
export function deleteCustomApplyApi(app_no) {
  return httprequest({
    url: `/api/v2/custom-app?app_no=${app_no}`,
    method: "delete",
    showLoad: false,

    dataStatus: 1,
  });
}

// 创建智能体会话
export function createApplyDialogApi(data) {
  return httprequest({
    url: `/api/v2/custom-app/session`,
    method: "post",
    data,
    showLoad: false,

    dataStatus: 1,
  });
}

export function statisticVisitApi(type) {
  return httprequest({
    url: `/api/v2/statistic/visit?type=${type}`,
    method: "post",
    showLoad: false,
    data: { type }, // 此接口需要data里面有数据才响应
    notEncryptUrl: true, // url不加密
    dataStatus: 1,
  });
}

// 查询对话应用信息
export function selectApplyDialogApi(data) {
  return httprequest({
    url: `/api/v2/custom-app/detail`,
    method: "get",
    data,
    showLoad: false,

    dataStatus: 1,
  });
}

// 删除对话应用信息
export function delApplyDialogApi(session_id, params) {
  let url = params
    ? `/api/v2/clear/question-answer`
    : `/api/v2/clear/question-answer?session_id=${session_id}`;
  return httprequest({
    url,
    method: "delete",
    showLoad: false,
    data: params,
    dataStatus: 1,
    hideError: true,
  });
}

// 存会话记录
export function chatQuestion(data) {
  return httprequest({
    url: "/api/v2/chat-question",
    method: "post",
    showLoad: false,
    dataStatus: 1,
    data,
  });
}
// 编辑会话记录
export function editChatQuestionApi(data) {
  return httprequest({
    url: "/api/v2/chat-question/voice",
    method: "post",
    showLoad: false,
    dataStatus: 1,
    data,
  });
}
// 查询会话
export function chatConversation(data) {
  return httprequest({
    url: `/api/v2/conversation`,
    method: "get",
    data,
    // showLoad: false,
    hideErrToast: true,
    dataStatus: 1,
  });
}

// 查询会话记录
export function chatHistory(data) {
  return httprequest({
    url: `/api/v2/history?page=${data.page}&page_size=${data.pageSize}&session_id=${data.session_id}`,
    method: "get",
    // showLoad: false,
    dataStatus: 1,
  });
}
// 删除会话记录
export function chatDelConversation(data) {
  let url;
  if (data.sessionIds) {
    url = `/api/v2/conversation`;
  } else {
    url = `/api/v2/conversation?session_id=${data.session_id}${
      data.is_all ? "&is_all=1" : ""
    }`;
  }
  return httprequest({
    url,
    method: "delete",
    // showLoad: false,
    data: data.sessionIds ? { session_ids: data.sessionIds } : undefined,
    dataStatus: 1,
  });
}

// 查询会话
export function postChatConversation(data) {
  return httprequest({
    url: `/api/v2/conversation`,
    method: "post",
    data,
    // showLoad: false,
    // hideErrToast: true,
    dataStatus: 1,
  });
}

// 分享会话
export function conversationShare(data) {
  return httprequest({
    url: `/api/v2/conversation-share`,
    method: "post",
    data,
  });
}

// 获取分享会话
export function getConversationShare(data) {
  return httprequest({
    url: `/api/v2/conversation-share?share_id=${data.share_id}`,
    method: "get",
  });
}

export function postNewComment(data) {
  return httprequest({
    url: `/api/v2/add-comment`,
    method: "post",
    data,
  });
}

export function commentList(data) {
  return httprequest({
    url: `/api/v2/app-comment/${data.type}`,
    method: "get",
  });
}

export function createConvertTask(data) {
  return httprequest({
    url: `/api/task/ocr`,
    method: "post",
    data,
  });
}

export function getConvertProgress(data) {
  return httprequest({
    url: `/api/task/ocr`,
    method: "get",
    data,
  });
}

// 查询联网回答的状态
export function getInternetCheckStatus(params) {
  return httprequest({
    url: `/api/v2/check-status?${params}`,
    method: "get",
    hideError: true,
  });
}

// 查询联网回答的链接内容
export function getInternetLinks(params) {
  return httprequest({
    url: `/api/v2/search-ref-links?${params}`,
    method: "get",
    hideError: true,
  });
}

// 创建文档聊天
export function getChatDocumentCreate(data) {
  // return axiosHttp({
  return httprequest({
    // headers: {
    //   Accept: "*/*",
    //   "Content-Type": "multipart/form-data",
    // },
    url: "/api/v2/chat-document",
    method: "post",
    useApi: "chatApiUrl",
    dataStatus: 1,
    data,
  });
}

// 获取文档列表
export function getChatDocumentList() {
  return httprequest({
    url: `/api/v2/chat-document`,
    method: "get",
    hideError: true,
  });
}

// 删除文档
export function getDeleteChatDocument(params) {
  return httprequest({
    url: `/api/v2/chat-document/${params.id}`,
    method: "delete",
    hideError: true,
  });
}

// 获取分词
export function getJiebaApi(data) {
  return httprequest({
    url: `/api/v2/jieba`,
    method: "post",
    useApi: "chatApiUrl",
    dataStatus: 1,
    data,
  });
}

// 检测图片
export function getDetectImage(params) {
  return httprequest({
    url: `/api/v2/detect-image?image=${params}`,
    method: "get",
    useApi: "chatApiUrl",
    dataStatus: 1,
    hideError: true,
  });
}

// 获取首页热点问题
export function getTopNews() {
  return httprequest({
    url: `/api/v2/top-news`,
    method: "get",
    dataStatus: 1,
    hideError: true,
  });
}

//判断PDF内容 data: {url: xxx}, ret: isScan: bool
export function getPDFContentTypeApi(data) {
  return httprequest({
    url: `/api/v2/aippt/check-scan`,
    method: "post",
    data,
  });
}
